// utils/storageFallback.ts
import storage from 'redux-persist/lib/storage';
import type { Storage } from 'redux-persist';
import config from '../../config';

const createNoopStorage = (): Storage => {
  return {
    getItem: async (_key: string) => null,
    setItem: async (_key: string, value: string) => value,
    removeItem: async (_key: string) => {},
  };
};

function isLocalStorageAvailable(): boolean {
  if (typeof window === 'undefined' || !window.localStorage) return false;

   // 🔥 Clear localStorage if REACT_APP_LOCAL_STORAGE=false
  // if (config.LOCAL_STORAGE === 'false') {
  //   console.warn('[redux-persist] 🧹 Config flag disabled localStorage. Clearing now...');
  //   try {
  //     window.localStorage.clear();
  //   } catch (e) {
  //     console.error('[redux-persist] ❌ Failed to clear localStorage:', e);
  //   }
  //   // return false; // fallback to noop
  // }


  try {
    const testKey = '__redux_persist_test__';
    window.localStorage.setItem(testKey, 'test');
    window.localStorage.removeItem(testKey);
    return true;
  } catch (e: any) {
    if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
      console.warn('[redux-persist] 🚨 Quota exceeded. Attempting to clear localStorage.');
      try {
        window.localStorage.clear();
        // Retry test after clearing
        const testKey = '__redux_persist_test_retry__';
        window.localStorage.setItem(testKey, 'retry');
        window.localStorage.removeItem(testKey);
        console.info('[redux-persist] ✅ Cleared localStorage and reinitialized it.');
        return true;
      } catch (clearError) {
        console.error('[redux-persist] ❌ Failed to recover localStorage after clearing:', clearError);
        return false;
      }
    }

    console.error('[redux-persist] ❌ localStorage test error:', e);
    return false;
  }
}

const safeStorage: Storage = isLocalStorageAvailable() ? storage : createNoopStorage();

console.log(
  safeStorage === storage
    ? '[redux-persist] ✅ Using localStorage for persistence.'
    : '[redux-persist] ⚠ localStorage unavailable. Falling back to noopStorage (persistence disabled).'
);

export default safeStorage;
